<template>
  <page-table />
</template>
<script>
import PageTable from './components/table'
export default {
  name: 'ecom-awsReport-advertisingList',
  components: { PageTable },
}
</script>
